"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var autosizeLibray = _interopRequireWildcard(require("./autosize"));
var _ui = require("../../ui");
require("../../../src/ui/input/input.module.scss");
var _uuid = require("uuid");
var _excluded = ["autosize", "className", "color", "disabled", "editable", "icon", "isClearable", "iconTooltip", "label", "readOnly", "searchPlaceholder", "size", "state", "tooltip", "value", "variant", "onBlur", "onChange", "onEnter", "onFocus", "onKeyDown"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
// accessibility ok

var Input = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var autosize = props.autosize,
    className = props.className,
    color = props.color,
    disabled = props.disabled,
    editable = props.editable,
    icon = props.icon,
    isClearable = props.isClearable,
    iconTooltip = props.iconTooltip,
    label = props.label,
    readOnly = props.readOnly,
    searchPlaceholder = props.searchPlaceholder,
    size = props.size,
    state = props.state,
    tooltip = props.tooltip,
    value = props.value,
    variant = props.variant,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onEnter = props.onEnter,
    onFocus = props.onFocus,
    onKeyDown = props.onKeyDown,
    attributesOriginal = _objectWithoutProperties(props, _excluded),
    attributes = attributesOriginal,
    labelItem = null,
    inputBefore = null,
    inputAfter = null;
  var _React$useState = React.useState(!!value),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isFilled = _React$useState2[0],
    _setIsFilled = _React$useState2[1];
  var isFocusedHook = React.useRef(false);
  var textarea = React.useRef(null);
  var _React$useState3 = React.useState('kui-input--' + (0, _uuid.v4)()),
    _React$useState4 = _slicedToArray(_React$useState3, 1),
    uniqueClass = _React$useState4[0];
  var timer = React.useRef(null);
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    cursor = _React$useState6[0],
    setCursor = _React$useState6[1];
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isCmdZ = _React$useState8[0],
    setCmdZ = _React$useState8[1];
  className = (0, _utils.ClassNames)('kui-input', uniqueClass, color ? 'kui-input--color_' + color : null, disabled ? 'kui-input--disabled' : null, isFilled || !!value ? 'kui-input--filled' : null, !autosize ? 'kui-input--noresize' : null, readOnly ? 'kui-input--readonly' : null, state ? 'kui-input--state_' + state : null, variant ? 'kui-input--variant_' + variant : null, size ? 'kui-input--size_' + size : null, className);
  attributes.className = 'kui-input__item';
  attributes.onChange = function (e) {
    _setIsFilled(!!e.target.value);
    if (onChange) onChange(e);
    setCursor(e.target.selectionStart);
  };
  attributes.onKeyDown = function (e) {
    if (e && e.key === 'Enter') {
      if (!autosize) e.preventDefault();
      if (onEnter) onEnter(e);
    }
    if (e && e.metaKey && e.key === 'z') {
      setCmdZ(true);
    }
    if (onKeyDown) onKeyDown(e);
  };

  /**
   * Проблема: при клике на иконку инпут получает одновременно onBlur и onFocus
   */

  attributes.onBlur = function (e) {
    if (!document.hasFocus()) return;
    if (e) e.persist();
    timer.current = setTimeout(function () {
      if (isFocusedHook.current) {
        var classes = (0, _utils.getParentsClasses)(e.relatedTarget, [uniqueClass]);
        if (!classes.includes(uniqueClass)) {
          isFocusedHook.current = false;
          if (onBlur) onBlur(e);
        }
      }
    }, 200);
  };
  attributes.onFocus = function (e) {
    if (e) e.persist();
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(function () {
      if (!isFocusedHook.current) {
        isFocusedHook.current = true;
        if (onFocus) onFocus(e);
      }
    }, 100);
  };

  /**
   * KNB-2481 bug with input blur/focus on ios/macos https://codepen.io/cliener/pen/ooGpwW
   * solution from https://github.com/cliener/input-fixer
   */
  var lastEventTime = React.useRef(0);
  var throttleDuration = 300; // ms
  var throttleEvent = function throttleEvent(event) {
    var timeStamp = event.timeStamp;
    if (timeStamp < lastEventTime.current + throttleDuration) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
    lastEventTime.current = timeStamp; // Only set the new time stamp if the event is valid
  };
  attributes.onFocusCapture = throttleEvent;
  attributes.onBlurCapture = throttleEvent;
  if (label) {
    labelItem = /*#__PURE__*/React.createElement("div", {
      className: "kui-label__item"
    }, label);
  }
  var clearInput = function clearInput(e) {
    if (disabled) return;
    e.preventDefault();
    _setIsFilled(false);
    textarea.current.value = '';
    if (variant !== 'datepicker') {
      textarea.current.focus();
    }
    if (onChange) onChange(_objectSpread(_objectSpread({}, e), {}, {
      target: textarea.current // fix target to input for Datepicker
    }));
  };
  var iconClear = /*#__PURE__*/React.createElement(_ui.Icon, {
    xlink: "clear",
    size: 24,
    tabIndex: -1 // for onBlur relatedTarget
    ,
    className: "kui-input__icon kui-input__icon--clear",
    onClick: clearInput
  });
  var getIconOrTooltip = function getIconOrTooltip() {
    if (iconTooltip) {
      var tooltipProps = typeof iconTooltip === 'string' ? {
        value: iconTooltip
      } : iconTooltip;
      return /*#__PURE__*/React.createElement(_ui.Tooltip, tooltipProps, iconClear);
    }
    return iconClear;
  };
  if (isClearable) {
    inputAfter = getIconOrTooltip();
  }
  if (variant === 'arrow' || variant === 'header') {
    if (variant === 'arrow' && icon) {
      className = (0, _utils.ClassNames)(className, 'kui-input--variant_search');
      inputBefore = /*#__PURE__*/React.createElement("span", {
        className: "kui-input-search"
      }, /*#__PURE__*/React.createElement(_ui.Icon, {
        xlink: icon,
        size: 24,
        tabIndex: -1,
        className: "kui-input-search__icon"
      }));
    }
    inputAfter = /*#__PURE__*/React.createElement(_ui.Icon, {
      xlink: "arrow-down",
      size: 24,
      tabIndex: -1 // for onBlur relatedTarget
      ,
      className: "kui-input__icon kui-input__icon--arrow"
    });
  } else if (variant === 'datepicker') {
    attributes.readOnly = !editable;
    autosize = false;
    icon = icon || 'calendar';
    var iconCalendar = /*#__PURE__*/React.createElement(_ui.Icon, {
      xlink: icon,
      size: 24,
      tabIndex: -1 // for onBlur relatedTarget
      ,
      className: "kui-input__icon"
    });
    if (isClearable) {
      inputAfter = isFilled ? getIconOrTooltip() : iconCalendar;
    } else {
      inputAfter = iconCalendar;
    }
  } else if (variant === 'search') {
    inputBefore = /*#__PURE__*/React.createElement("span", {
      className: "kui-input-search"
    }, /*#__PURE__*/React.createElement(_ui.Icon, {
      xlink: icon || 'search',
      size: 24,
      tabIndex: -1 // for onBlur relatedTarget
      ,
      className: "kui-input-search__icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "kui-input-search__placeholder"
    }, searchPlaceholder));
    if (isClearable && (isFilled || !!value)) {
      inputAfter = getIconOrTooltip();
    } else {
      inputAfter = /*#__PURE__*/React.createElement(_ui.Icon, {
        xlink: "arrow-down",
        size: 24,
        tabIndex: -1,
        className: "kui-input__icon kui-input__icon--arrow"
      });
    }
  } else if (icon && variant === 'withicon') {
    inputAfter = /*#__PURE__*/React.createElement(_ui.Icon, {
      xlink: icon,
      size: 24,
      tabIndex: -1 // for onBlur relatedTarget
      ,
      className: "kui-input__icon"
    });
  }
  var Tag = autosize ? 'textarea' : 'input';
  React.useEffect(function () {
    textarea.current.value = value;
    _setIsFilled(!!value);
    requestAnimationFrame(function () {
      // подождать autosizeLibray.default. был баг высоты email в boardDetails
      autosizeLibray["default"].update(textarea.current);
    });
  }, [value]);

  // fix safari cursor jump: https://stackoverflow.com/questions/46000544/react-controlled-input-cursor-jumps
  React.useEffect(function () {
    if (isCmdZ) {
      // фикс путает выделение текста при команд зет
      setCmdZ(false);
      return;
    }
    if (!cursor) return;
    try {
      // many input types do not support selection
      textarea.current.setSelectionRange(cursor, cursor);
    } catch (e) {/* noop */}
  }, [cursor]);
  React.useEffect(function () {
    if (autosize) autosizeLibray["default"](textarea.current);
    return function () {
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);
  React.useImperativeHandle(ref, function () {
    return {
      setIsFilled: function setIsFilled(value) {
        _setIsFilled(!!value);
      },
      getBoundingClientRect: function getBoundingClientRect() {
        return textarea.current.getBoundingClientRect();
      },
      setFocus: function setFocus(e) {
        textarea.current.focus();
        attributes.onFocus(e);
      },
      getInput: function getInput() {
        return textarea.current;
      }
    };
  });
  var inputElement = /*#__PURE__*/React.createElement(Tag, _extends({
    disabled: disabled,
    readOnly: readOnly,
    rows: 1,
    ref: textarea
  }, attributes));
  if (tooltip) {
    var tooltipProps = typeof tooltip === 'string' ? {
      value: tooltip
    } : tooltip;
    if (state && !tooltipProps.state) tooltipProps.state = state;
    inputElement = /*#__PURE__*/React.createElement(_ui.Tooltip, tooltipProps, inputElement);
  }
  return /*#__PURE__*/React.createElement(_ui.Label, {
    className: className,
    ref: ref
  }, labelItem, inputBefore, inputElement, inputAfter);
});
exports.Input = Input;
Input.defaultProps = {
  autosize: true,
  color: null,
  disabled: false,
  editable: true,
  icon: null,
  isClearable: false,
  iconTooltip: null,
  label: null,
  searchPlaceholder: 'Search',
  size: null,
  state: null,
  tooltip: null,
  value: '',
  variant: null,
  onEnter: function onEnter() {
    return undefined;
  }
};
Input.displayName = 'Input';